import _ from 'lodash';
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import './assets/font/iconfont.css';
import './assets/iconfont-cohort/iconfont.css';
import store from './store/index.js';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import {ApolloLink} from 'apollo-link'
import {onError} from 'apollo-link-error'
import api from './api';
import VueLazyload from 'vue-lazyload'
import VueKonva from 'vue-konva'
import { RetryLink } from "apollo-link-retry";
import Print from 'vue-print-nb';
Vue.use(Print);
import { Message } from 'element-ui';
Vue.component(Message.name, Message)
import FormMaking from 'form-making';
import 'form-making/dist/FormMaking.css'
Vue.use(FormMaking)
import axios from 'axios';
// import 'form-making/dist/FormMaking.css'
import './assets/style/FormMaking.less'
axios.defaults.withCredentials=true;//让ajax携带cookie

Vue.prototype.$axios = axios;
Vue.use(FormMaking);
const linkRetry = new RetryLink({
  delay: {
    initial: 10,
    max: Infinity,
    jitter: false
  },
  attempts: {
    max: 0,
    retryIf: (error, _operation) => {
      return !!error
    }
  }
});

Vue.use(VueKonva);

// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: require('./assets/loading2.gif'),
  attempt: 1,
  dispatchEvent: true,
})
// let win: any = window;
// win.isWin32 = process.platform === "win32";
// if (win.isWin32) {
//   win.ipcRenderer = require("electron").ipcRenderer;
//   win.remote = require("electron").remote;
// }
const httpLink = new HttpLink({
  uri: api.server + '/graphql',
  credentials: 'include'
});
const middlewareLink = new ApolloLink((operation, forward) => {
  // operation.setContext({
  //   headers: {
  //     'access-token': sessionStorage.getItem('access-token') || null
  //   }
  // })

  return forward(operation).map(response => {
    return response
  })
})
const errorLink = onError(({networkError, response}) => {
  let errorMsg = ''
  if (!!response && response.errors !== undefined && response.errors.length) {
    errorMsg = !response.errors[0].message ? '服务器错误' : response.errors[0].message
  }
  if (!!networkError) {
    errorMsg = networkError.message
    // if (networkError.result !== undefined) {
    //   errorMsg = networkError.result.success === false ? networkError.result.message : networkError.result.error
    // }
  }
  if (!!errorMsg) {
    if(errorMsg  === "Failed to fetch"){
      Message.error('连接超时，请检查网络是否中断！');
    }
  }
})
const authLink = middlewareLink.concat(httpLink)
const cache = new InMemoryCache();
const apolloClient = new ApolloClient({
  // link: linkRetry.concat(httpLink),
  link: errorLink.concat(authLink),
  cache,
})
// https://www.jianshu.com/p/be267b65452e 参考文档
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueApollo);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
// 自定义指令必须在实例创建之前定义
Vue.directive("drag", {
  inserted: (el: any, binding: any) => {
    el.onmousedown = (e) => {
      let disX = e.pageX - el.offsetLeft;
      let disY = e.pageY - el.offsetTop;
      document.onmousemove = (e) => {
        el.style.left = e.pageX - disX + 'px';
        el.style.top = e.pageY - disY + 'px';
      }
      document.onmouseup = () => {
        document.onmousemove = document.onmouseup = null;
      }
    }
  }
});
Vue.prototype.downloadFile = (data) => {
  if (!data) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', '预约信息.xlsx')
  document.body.appendChild(link)
  link.click()
};
// 根据用户操作权限(auths)，包括美容、手术、住院、AI、美容项目自定义等等，设置按键 是否 display
const aclDirective = {
  inserted: (el, binding) => { // 在被绑定的元素插入到dom中时
    const hasAuth = (needAuths,haveAuths) => { // 判断用户是否拥有权限的function
    // implement 
    return haveAuths.indexOf(needAuths)>-1
    }
    const havaAuths =store.state.controller.auths ; // 用户拥有的权限列表
    if (!hasAuth(binding.value[0], havaAuths)) { // binding.value 可以获得绑定指令时传入的参数
      el.style = "display:none"; // 修改元素的可见状态  
    }
  }
}
Vue.directive('acl', aclDirective); // 全局注册指令

// 根据用户影像模态权限(intellModel)，设置tab 是否 display，在Intelligent.vue内使用
const editDirective = {
  inserted: (el, binding) => { // 在被绑定的元素插入到dom中时
    const hasAuth = (needAuths,haveAuths) => { // 判断用户是否拥有权限的function
      return haveAuths.indexOf(needAuths)>-1
    }
    const havaAuths = store.state.controller.intellModel; // 用户拥有的权限列表
    if (!hasAuth(binding.value[0], havaAuths)) { // binding.value 可以获得绑定指令时传入的参数
      el.style = "display:none"; // 修改元素的可见状态 
    }
  }
}
Vue.directive('edit', editDirective); // 全局注册指令

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted:  (el)=> {
    // 聚焦元素
    el.focus()
  }
});
router.beforeEach( async (to, from, next) => {
  // 不用登录即可打开的页面；2025-07 增加表单填写页面 followupForm、小程序重定向页面 WxRedirect、服务号绑定手机号回调API
  let whiteList = ['login', 'followupForm', 'WxRedirect','bindPhone'];
  if(to.name!=='login' && to.name!=='followupForm'  && to.name!=='WxRedirect' && to.name!=='bindPhone') { 
    if(store.state.controller.hasLogin || sessionStorage.getItem("username")) {
      await store.dispatch('controller/getController',apolloProvider);
      next();
    } else {
      next('login');
    }
  } else {
    next();
  }
})
new Vue({
  router,
  store,
  apolloProvider,
  created() {
    if (window['isWin32'.toString()]) {
      const settingStr = localStorage.getItem('setting');
      if (settingStr) {
        window['ipcRenderer'.toString()].send('service-setting', JSON.parse(settingStr));
      }
    }
  },
  render: (h) => h(App),
}).$mount('#app');

